import UIStack from "./UIStack";
import { useUIStack } from "./useUIStack";
export default UIStack;
export { useUIStack };
//# sourceMappingURL=index.js.map